/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Setup_Okta_Step2Inputs */



/**
* | output |
* | --- |
* | "Select SCIM 2.0 as the provisioning type" |
*
* @param {Scim_Setup_Okta_Step2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_setup_okta_step2 = /** @type {((inputs?: Scim_Setup_Okta_Step2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Setup_Okta_Step2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie SCIM 2.0 als Bereitstellungstyp")
	return /** @type {LocalizedString} */ ("Select SCIM 2.0 as the provisioning type")
});